import { Route,Routes} from "react-router-dom"
import Dashboard from "../pages/dashboard"

const SalesRoute = () => {
  return (
    // <>
    //     <Route path='sales/orders' exact element={<Dashboard />} />
    //     <Route path='sales/invoices' exact element={<Dashboard />} />
    // </>
        <Route path='sales/returns' exact element={<Dashboard />} />
  )
}

export default SalesRoute